module.exports = __webpack_public_path__ + "static/media/timeline-1999.d7c20c8c.webp";